<template>
  <div>
    <!--기본정보-->
    <field-select-module v-model="form.stdInfo" :board="this.board" :is-print="isPrint" />

    <!-- 평가대상정보 -->
    <div v-if="!!form.stdInfo.field_id" class="mt-component-form">
      <vs-row class="my-4">
        <vs-col>
          <h5><i class="dot"></i>{{ $t('평가대상') }}</h5>
        </vs-col>
      </vs-row>
      <div class="grid grid-cols-12 gap-x-6 gap-y-4">
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('부서(업체)명') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.companyName }}</p>
          <company-selector
            v-else v-model="form.inputB_0"
            :company-name="form.companyName"
            class="w-full flex-1"
            :fieldId="form.stdInfo.field_id"
            @select="targetCompany"/>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('소속명') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_1 }}</p>
          <ml-input v-else v-model="form.inputB_1" class="w-full flex-1"/>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('부서명') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
          <ml-input v-else v-model="form.inputB_2" class="w-full flex-1"/>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('직책') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_3 }}</p>
          <ml-input v-else v-model="form.inputB_3" class="w-full flex-1"/>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('피평가자') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
          <ml-input v-else v-model="form.inputB_4" class="w-full flex-1"/>
        </div>
        <div class="col-span-4 flex items-center">
          <div class="label-text mr-4">{{ $t('평가일') }}</div>
          <p v-if="isPrint" class="print-input">{{ form.inputB_5 }}</p>
          <date-selector :readonly="board.readonly" v-else v-model="form.inputB_5" class="w-full flex-1" />
        </div>
        <!--        <div class="col-span-4 flex items-center">-->
        <!--          <div class="label-text mr-4">{{ $t('점검일') }}</div>-->
        <!--          <p v-if="isPrint" class="print-input">{{ form.inputB_6 }}</p>-->
        <!--          <date-selector-->
        <!--            :readonly="board.readonly"-->
        <!--            v-else-->
        <!--            v-model="form.inputB_6"-->
        <!--            class="w-full flex-1"-->
        <!--          />-->
        <!--        </div>-->
        <!--        <div class="col-span-4 flex items-center">-->
        <!--          <div class="label-text mr-4">{{ $t('점검장소') }}</div>-->
        <!--          <p v-if="isPrint" class="print-input">{{ form.inputB_7 }}</p>-->
        <!--          <ml-input-->
        <!--            v-else-->
        <!--            v-model="form.inputB_7"-->
        <!--            class="w-full flex-1"-->
        <!--          />-->
        <!--        </div>-->
      </div>
    </div>

    <!-- 업무 수행 여부 -->
    <table-business v-if="!!form.stdInfo.field_id" :dataTable="dataTable" :list="form.list" :isPrint="isPrint" :isReadonly="board.readonly" title="평가표" @update-list-check="updateListCheck">
      <template #footer>{{ $t('※ 이행되지 않았을 시 추가적인 조치 필요(인력 배치, 예산의 추가 편성·집행등의 필요한 조치 시행)') }}<br />
        ※ 반기 1회 점검
      </template>
    </table-business>

    <file-upload-module :readonly="board.readonly" :is-print="isPrint" class="mt-component-form w-full" v-model="form.fileList" />
    <!-- <img class="fill-current" src="@/assets/images/temporary/102.svg" /> -->
  </div>
</template>

<script>
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import TableBusiness from "@/components/TableBusiness";
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PhotoUploadGridModule from "@/views/modules/PhotoUploadGridModule";

export default {
  components: {
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
    TableBusiness,
    FileUploadModule,
    FieldSelectModule,
    PhotoUploadGridModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    updateListCheck(indexRows, text) {
      this.form.list[indexRows].is_checked = text;
    },
    targetCompany(value) {
      this.form.companyName = value.com_name;
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        list: [
          {
            text: "위험성평가 실시 확인",
            is_checked: "",
            note: "",
          },
          {
            text: "작업의 중지와 대피에 대한 운영(필요 시)",
            is_checked: "",
            note: "",
          },
          {
            text: "도급 시 산업재해 예방조치(협의체 운영 등)",
            is_checked: "",
            note: "",
          },
          {
            text: "관계수급인 간 산업안전보건관리비 사용에 관한 협의·조정 및 집행·감독",
            is_checked: "",
            note: "",
          },
          {
            text: "안전인증대상기계 등과 자율안전확인대상 기계 등의 사용 여부 확인",
            is_checked: "",
            note: "",
          },
        ],

        inputB_0: "",
        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        inputB_7: "",

        photoList: [],

        fileList: [],
        companyName: "",
      },
      dataTable: [
        {
          text: "위험성평가 실시 확인",
          index: 1,
        },
        {
          text: "작업의 중지와 대피에 대한 운영(필요 시)",
          index: 2,
        },
        {
          text: "도급 시 산업재해 예방조치(협의체 운영 등)",
          index: 3,
        },
        {
          text: "관계수급인 간 산업안전보건관리비 사용에 관한 협의·조정 및 집행·감독",
          index: 4,
        },
        {
          text: "안전인증대상기계 등과 자율안전확인대상 기계 등의 사용 여부 확인",
          index: 5,
        },
      ],
    };
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
.label-text {
  width: 114px;
  font-weight: 500;
  font-size: 14px;
}

.mt-component-form {
  margin-top: 15px;
}

.upload-content {
  border: $border;

  &:last-child {
    border-left: none;
  }

  &__file {
    width: 100%;
    padding: 14px;
    height: 416px;
  }

  &__input {
    height: 54px;
    background: #f9f9f9;
    border-top: $border;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
